module.exports = __webpack_public_path__ + "media/images/pages/ai/photo-1-a1fd9557981b56815469eade5cab41f0.png";